import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import WaitlistTable from "@/components/waitlist/waitlist-table";

const waitlistSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_super/super/waitlist")({
  validateSearch: waitlistSearchSchema,
  component: WaitlistPage,
});

function WaitlistPage() {
  const searchParams = Route.useSearch();

  return (
    <WaitlistTable
      currentPage={searchParams.page}
      basePath="/super/waitlist"
      searchParams={searchParams}
    />
  );
}